import './fondi-slider.scss';
import Splide from '@splidejs/splide';

export class FondiSlider {
  constructor() {
    this.el = document.querySelector('.fondi-slider__splide');
    if (!this.el) return;

    this.mediaQuery = window.matchMedia('(min-width: 992px)');
    this.splide = null;

    this.init();
  }

  init() {
    this.handleSlider(this.mediaQuery);

    this.mediaQuery.addEventListener('change', (e) => {
      this.handleSlider(e);
    });
  }

  handleSlider(e) {
    const slidesCount = this.el.querySelectorAll('.splide__slide').length;

    if (e.matches) {
      if (slidesCount > 4) {
        if (!this.splide) {
          this.mountSlider(4);
        }
      } else {
        this.destroySlider();
      }
    } else if (!this.splide) {
      this.mountSlider(1.2);
    } else {
      this.splide.options = { perPage: 1.2 };
    }
  }

  mountSlider(perPage) {
    this.splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      perPage,
      focus: 0,
      drag: true,
      trimSpace: true,
      snap: true,
      gap: '25px',
    });

    this.splide.mount();
    this.initArrows();
  }

  destroySlider() {
    if (this.splide) {
      this.splide.destroy(true);
      this.splide = null;
    }
  }

  initArrows() {
    const prev = this.el.querySelector('.splide__arrow--prev');
    const next = this.el.querySelector('.splide__arrow--next');

    const updateArrows = () => {
      const { index } = this.splide;
      const last = this.splide.length - this.splide.options.perPage;

      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }

      if (this.splide.length <= this.splide.options.perPage) {
        prev.classList.add('is-removed');
        next.classList.add('is-removed');
      }
    };

    updateArrows();
    this.splide.on('mounted move', updateArrows);
  }
}
